import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { Column } from '@src/app/modules/table/types';

import { ColumnsSettingComponent } from '../../columns-setting.component';

@Component({
  selector: 'table-columns-setting-dialog',
  standalone: true,
  imports: [DialogModule, ColumnsSettingComponent],
  templateUrl: './dialog.component.html',
  styleUrl: './dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.Default,
})
export class ColumnsSettingDialog {
  @Input() visible = false;
  @Output() visibleChange = new EventEmitter<boolean>();

  @Input() allColumns: Array<Column> = [];

  @Input() selectedColumns: Array<Column> = [];
  @Output() selectedColumnsChange = new EventEmitter<Array<Column>>();
}
